import { useMemo } from 'react';
import { FilterTag } from '../../../filter-tags/components/filter-tag';
import { FilterTagAlternate } from '../../../filter-tags/types';
import { getFilterTagsFlattened } from '../../../filter-tags/utils';

export function useRenderTagList(tags: FilterTagAlternate) {
  return useMemo(() => {
    // const excluded = Object.keys(tags.excluded).flatMap((k) => tags.excluded[k]);
    return getFilterTagsFlattened(tags).map((item) => {
      return item.data?.map((d) => {
        return (
          <FilterTag
            key={d.value}
            data={d ?? []}
            info={item}
            field={item.field}
            utils={item.utils}
          />
        );
      });
    });
  }, [tags]);
}
